import React from "react";
import Helmet from "react-helmet";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import MetaData from "@clarion/foundation/dist/Helpers/components/MetaData";
const SiteMetaData = ({
  sitecoreContext,
  fields,
  protocol
}) => {
  const pageFields = sitecoreContext.route.fields;
  const origin = sitecoreContext?.siteSettings?.targetHostname;
  const jsonldData = JSON.stringify([{
    "@type": "WebSite",
    "@context": "http://schema.org",
    url: fields?.SchemaWebsiteUrl?.value || "",
    name: fields?.SchemaWebsiteName?.value || ""
  }, {
    "@type": "Organization",
    "@context": "http://schema.org",
    logo: fields?.SchemaLogo?.value?.src || "",
    url: fields?.SchemaWebsiteUrl?.value || "",
    name: fields?.SchemaWebsiteName?.value || ""
  }]);
  const canonicalUrl = pageFields?.CanonicalUrl?.value?.href.indexOf("http") === 0 ? pageFields.CanonicalUrl.value.href : protocol + origin + pageFields?.CanonicalUrl?.value?.href;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, jsonldData)), /*#__PURE__*/React.createElement(MetaData, {
    fields: fields,
    pageFields: pageFields,
    canonicalUrl: canonicalUrl,
    origin: origin
  }));
};
export default withSitecoreContext()(SiteMetaData);